<!-- eslint disable -->
<template>
    <div id="login-wrap">
        <header>
            <h1>
                <img src="https://cdn.nucarf.net/nyb/v1.0/images/etclogo.png">
            </h1>
        </header>
        <main>
            <div id="loginBox">
                <div id="login">
                    <!-- <h1>牛卡福网络</h1> -->
                    <router-link
                        v-show="isLoginWindow"
                        :vuex-modeule-name="vuexModeuleName"
                        to="/details"
                    />
                </div>
                <!-- 黑色 遮盖罩罩 -->
                <transition name="fade">
                    <div
                        v-show="isPwd || isCompany"
                        class="login-cover-wrap"
                    />
                </transition>
                <!-- 登录弹出框 -->
                <index-login-window
                    v-show="isLoginWindow"
                    :vuex-modeule-name="vuexModeuleName"
                />
                <!-- 修改密码弹出框 -->
                <index-set-pwd-window
                    v-if="isPwd"
                    :vuex-modeule-name="vuexModeuleName"
                />
                <!-- 加入企业弹框 -->
                <div
                    v-for="(item, index) in loginData.companys"
                    :key="item.subDomain"
                >
                    <index-add-company-window
                        v-if="isCompany && !item.hasJoined"
                        :index="index"
                        :info="item"
                        :vuex-modeule-name="vuexModeuleName"
                    />
                </div>
            </div>
        </main>
        <!-- 底部 -->
        <footer>
            <!-- <ul class="flex">
                <li>
                    帮助
                </li>
                <li>隐私</li>
                <li>条款</li>
            </ul>-->
            <p>copyright©2019牛卡福网络技术部出品</p>
        </footer>
    </div>
</template>
<script>
import Axios from 'axios'
import { loginToUrl } from '@/utils'
import indexLoginWindow from './components/indexLoginWindow'
import indexSetPwdWindow from './components/indexSetPwdWindow'
import indexAddCompanyWindow from './components/indexAddCompanyWindow'
import { setCookie , getCookie} from '@/utils/index'
export default {
    components: {
        indexLoginWindow,
        indexSetPwdWindow,
        indexAddCompanyWindow,
    },
    data () {
        return {
            vuexModeuleName: 'loginModule',
        }
    },
    computed: {
        isLoginWindow () {
            return this.$store.state[this.vuexModeuleName].isLoginWindow
        },
        isPwd () {
            return this.$store.state[this.vuexModeuleName].isPwd
        },
        isCompany () {
            return this.$store.state[this.vuexModeuleName].isCompany
        },
        loginData () {
            return this.$store.state[this.vuexModeuleName].loginData
        }
    },
    created () {
        if (window.location.search.includes('redirect=authentication')) {
            setCookie('redirect', 'authentication', window.location.host.substring(window.location.host.indexOf('.')))
        }
        this.$nextTick(() => {
            this.$store.commit(this.vuexModeuleName + '/updateStateData', {
                isLoginWindow: true
            })
        })
    },
    async beforeRouteEnter (to, from, next) {
        let ShippersUserInfo = getCookie('ShippersUserInfo');
        try {
            ShippersUserInfo = JSON.parse(decodeURIComponent(ShippersUserInfo));
        } catch (error) {
            console.log("解析错误:", error,ShippersUserInfo.accessToken);
        }
        const config = {
            headers: {
            }
        };
        
        if(ShippersUserInfo && ShippersUserInfo.accessToken){
          config.headers['unified-token'] = ShippersUserInfo.accessToken;
        }
         console.log('config',config);
        let { data } = await Axios.get('/rest/passport/v1/login/nToken',config)
        if (data.code === 200) {
            loginToUrl(data.data.companys[0].subDomain)
        } else {
            next()
        }

    }
}
</script>
<style lang="scss" scoped>
.login-cover-wrap {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100%;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
#login-wrap {
    position: relative;
    overflow: auto;
    width: 100%;
    height: 100%;
}
header {
    height: 70px;
    z-index: 2;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    img {
        padding: 10px 20px 0 20px;
        width: 250px;
    }
}
main {
    max-width: 100%;
    min-width: 1260px;
    width: 100%;
    height: auto;
    background: #111a65;
}
#loginBox {
    max-width: 1200px;
    height: 720px;
    box-sizing: border-box;
    background: #111a65;
    padding: 100px 0 80px;
    margin: 0 auto;
    clear: both;
}
#login {
    background: url(./images/wps.png) left center / contain no-repeat;
    width: 550px;
    height: 100%;
    float: left;
    margin-right: 50px;
    a {
        display: block;
        width: 550px;
        height: 100%;
        cursor: pointer;
    }
}

.login-window {
    float: right;
    overflow: hidden;
}
footer {
    font-size: 14px;
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    color: rgba(109, 114, 120, 1);
    line-height: 70px;
    p {
        background: rgba(255, 255, 255, 1);
        text-align: center;
    }
}

@media screen and (max-width: 1680px) {
    #login .login-window {
        right: 10%;
    }
}
</style>
